import React from "react";
import PropTypes from "prop-types";
import { Modal, Nav, NavItem } from "react-bootstrap";
import MetadataStandards from "../../../helpers/metadata_standards";

export default class MetadataEditor extends React.Component {
  constructor(...args) {
    super(...args);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.updateMetadataProperty = this.updateMetadataProperty.bind(this);
    this.state = {
      edited_metadata: {},
      selected_tab: "iptc"
    };
  }

  save() {
    this.props.save(this.state.edited_metadata);
  }

  cancel() {
    this.props.cancel();
  }

  changeTab(selected_tab) {
    this.setState({ selected_tab });
  }

  updateMetadataProperty(key, value) {
    let { edited_metadata } = this.state;
    edited_metadata[key] = value;
    this.setState({ edited_metadata });
  }

  renderIPTC() {
    let { edited_metadata, selected_tab } = this.state;
    if (selected_tab == "iptc") {
      let properties = MetadataStandards.iptc_standard_properties();
      return properties.map((property, index) => {
        let { tag, label, group } = property;
        let value = Object.keys(edited_metadata).includes(tag)
          ? edited_metadata[tag]
          : this.props.metadata[tag];
        return (
          <div key={index} className="metadata-pair">
            <div className="metadata-key">{label}: </div>
            <input
              className="metadata-value"
              type="text"
              value={value}
              onChange={event =>
                this.updateMetadataProperty(tag, event.target.value)
              }
            />
          </div>
        );
      });
    }
  }

  renderIPTCExtended() {
    let { edited_metadata, selected_tab } = this.state;
    if (selected_tab == "iptc_extended") {
      let properties = MetadataStandards.iptc_extended_properties();
      return properties.map((property, index) => {
        let { tag, label, group } = property;
        let value = Object.keys(edited_metadata).includes(tag)
          ? edited_metadata[tag]
          : this.props.metadata[tag];
        return (
          <div key={index} className="metadata-pair">
            <div className="metadata-key">{label}: </div>
            <input
              className="metadata-value"
              type="text"
              value={value}
              onChange={event =>
                this.updateMetadataProperty(tag, event.target.value)
              }
            />
          </div>
        );
      });
    }
  }

  // TODO: allow editing of exif/xmp/non-iptc metadata. These fields have strict format requirements
  // and can cause the entire convert/download to fail if entired incorrectly.
  // renderMisc() {
  //   if (this.state.selected_tab == 'misc') {
  //     let iptc_properties = MetadataStandards.iptc_property_names()
  //     let misc_properties = Object.keys(this.state.metadata).filter(property => {
  //       return !iptc_properties.includes(property.toLowerCase())
  //     })
  //     return misc_properties.map((tag, index) => {
  //       let value = this.state.metadata[tag]
  //       return (
  //         <div key={index} className='metadata-pair'>
  //           <div className='metadata-key'>{tag}: </div>
  //           <input className='metadata-value' type='text' value={value} onChange={event => this.updateMetadataProperty(tag, event.target.value)}/>
  //         </div>
  //       )
  //     })
  //   }
  // }

  render() {
    return (
      <Modal className="metadata-editor" show={true} onHide={this.cancel}>
        <Nav
          className="metadata-editor-tabs"
          bsStyle="tabs"
          onSelect={this.changeTab}
        >
          <NavItem eventKey="iptc">IPTC</NavItem>
          <NavItem eventKey="iptc_extended">IPTC Extended</NavItem>
        </Nav>
        <Modal.Body>
          {this.renderIPTC()}
          {this.renderIPTCExtended()}
          <div className="metadata-buttons">
            <input
              className="save-button"
              type="submit"
              value="Save"
              onClick={this.save}
            />
            <input
              className="cancel-button"
              type="submit"
              value="Cancel"
              onClick={this.cancel}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

MetadataEditor.propTypes = {
  metadata: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};
